import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#FCFAF8] flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <span className="inline-block bg-[#FFF5F5] text-[#D48585] text-xs font-body font-semibold px-3 py-1 rounded-full mb-4">Legal</span>
        <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29] mb-2" data-testid="privacy-title">Privacy Policy</h1>
        <p className="font-body text-sm text-[#A89F91] mb-8">Last updated: March 2026</p>

        <div className="prose font-body text-[#4A4745] text-sm leading-relaxed space-y-6">
          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">1. Information We Collect</h2>
            <p>When you use {'{'}Beauty{'}'} Stashmart, we may collect the following types of information:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Account Information:</strong> Name, email address, password (stored as a secure hash), profile picture.</li>
              <li><strong>Profile Information:</strong> Skin type, skin concerns, beauty story, city, influencer status, and other details you choose to provide.</li>
              <li><strong>Transaction Data:</strong> Order details, payment status, shipping information, and delivery addresses.</li>
              <li><strong>Usage Data:</strong> Pages visited, features used, device type, browser type, and general interaction patterns to help us improve the service.</li>
              <li><strong>Communication Data:</strong> Messages exchanged on the Platform and customer support inquiries.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Operate, maintain, and improve the {'{'}Beauty{'}'} Stashmart marketplace.</li>
              <li>Process transactions and send related notifications (order confirmations, shipping updates).</li>
              <li>Verify user identities and manage the influencer verification process.</li>
              <li>Communicate with you about your account, orders, and platform updates.</li>
              <li>Detect and prevent fraud, abuse, and violations of our Terms and Conditions.</li>
              <li>Analyze usage patterns to improve user experience and develop new features.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">3. Data Sharing</h2>
            <p>We do not sell your personal data. We may share your information with:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Payment Partners:</strong> Duitku processes payment transactions. Your payment details are handled directly by Duitku under their privacy policy and security standards.</li>
              <li><strong>Logistics Partners:</strong> Delivery addresses and contact information may be shared with courier services to fulfill shipments.</li>
              <li><strong>Other Users:</strong> Your public profile information (display name, city, skin type, beauty story, influencer status) and listing details are visible to other platform users.</li>
              <li><strong>Legal Requirements:</strong> We may disclose information if required by Indonesian law, regulation, legal process, or governmental request.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">4. Data Security</h2>
            <p>
              We implement reasonable technical and organizational measures to protect your personal data against unauthorized access,
              alteration, disclosure, or destruction. Passwords are stored using industry-standard bcrypt hashing. However, no method
              of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">5. Data Retention</h2>
            <p>
              We retain your personal data for as long as your account is active or as needed to provide you with our services.
              If you delete your account, we will remove your personal data within a reasonable timeframe, except where we are
              required to retain certain data for legal, regulatory, or legitimate business purposes (such as transaction records).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Access and review the personal data we hold about you.</li>
              <li>Request correction of inaccurate data.</li>
              <li>Request deletion of your account and associated data.</li>
              <li>Withdraw consent for data processing where applicable.</li>
            </ul>
            <p className="mt-2">
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:hello@stashmart.store" className="text-[#D48585] underline">hello@stashmart.store</a>.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">7. Cookies &amp; Tracking</h2>
            <p>
              We use essential cookies and local storage to maintain your session and preferences. We do not currently use
              third-party tracking or advertising cookies. If this changes in the future, we will update this policy and
              provide appropriate notice.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated
              revision date. We encourage you to review this page periodically.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#2C2A29]">9. Contact</h2>
            <p>
              For questions or concerns regarding this Privacy Policy or your personal data, please contact us at{' '}
              <a href="mailto:hello@stashmart.store" className="text-[#D48585] underline">hello@stashmart.store</a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
